
















import IconUserImage from "@/common/components/icons/IconUserImage.vue";

import JUserSelectPanelBody from "@/general/components/pages/parts/ThanksPointUserSelection/JUserSelectPanelBody.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    IconUserImage,
    JUserSelectPanelBody
  }
})
export default class JUserSelectPanel extends Vue {
  @Prop({ type: Object, required: true }) userSelectDetail!: any;

  get date() {
    return this.userSelectDetail.date;
  }

  get url() {
    return this.userSelectDetail.url;
  }

  get icon() {
    return this.userSelectDetail.icon.medium;
  }

  get unread() {
    return this.userSelectDetail.unread;
  }

  get detailData() {
    const name = this.userSelectDetail.name;
    const id = this.userSelectDetail.id;
    const groupName = this.userSelectDetail.groupName;
    const usingEmployeeId = this.userSelectDetail.usingEmployeeId;
    return { name, id, groupName, usingEmployeeId };
  }

  emitOpenModal() {
    const userSelectDetail = this.userSelectDetail;
    const emitValue = Object.assign(userSelectDetail.sendTo, {
      icon: userSelectDetail.icon
    });
    this.$emit("emit-open-modal", { sendTo: emitValue });
  }
}
